import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import { Box, Checkbox, TextField, Typography } from "@mui/material";
import { useSuperAdminUserRole } from "../../../../context/SuperAdmin/UserRoleContext";
import { useState } from "react";

const OtherUsersMenu = () => {
  const { missingUsers, isAdding, toAddUsers, setToAddUsers } =
    useSuperAdminUserRole();

  const [searchText, setSearchText] = useState("");

  // Función para manejar la selección/deselección individual
  const handleCheckboxChange = (id: string) => {
    setToAddUsers((prev) =>
      prev.includes(id) ? prev.filter((comp) => comp !== id) : [...prev, id]
    );
  };

  // Función para seleccionar o deseleccionar todos
  const toggleSelectAll = () => {
    if (toAddUsers.length > 0) {
      setToAddUsers([]); // Si todos están seleccionados, deselecciona
    } else {
      setToAddUsers(missingUsers.map((user) => user.id_usuario)); // Selecciona todos
    }
  };

   // Filtro de usuarios por búsqueda
   const normalizedSearch = searchText.toLowerCase().trim();
   const filteredUsers = missingUsers.filter((usuario) => {
     const fullName = `${usuario.nombres} ${usuario.apellidos}`.toLowerCase();
     const email = usuario.email.toLowerCase();
     return (
       fullName.includes(normalizedSearch) || email.includes(normalizedSearch)
     );
   });

  return (
    <Box
      sx={{
        width: "100%",
        border: "1px solid rgba(51, 107, 135, 0.5)",
        borderRadius: "8px",
        padding: "8px 16px",
        transition: "all 0.3s ease",
      }}
    >
      {/* Título */}
      <Typography variant="h6" component="h2" color="#000">
        Otros Usuarios{" "}
        <Typography component="span" color="#73767E" fontSize="20px">
          {toAddUsers.length > 0
            ? `(${toAddUsers.length}/${missingUsers.length})`
            : `(${missingUsers.length})`}
        </Typography>
      </Typography>

      {/* Search bar */}
      <TextField
        fullWidth
        placeholder="Buscar por nombre o email"
        size="small"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        sx={{
          marginTop: "8px",
          backgroundColor: "#F9F9F9",
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
          },
        }}
      />

      {/* Header con checkbox + nombre + email */}
      {missingUsers.length > 0 && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            px: "8px",
            py: "14px",
            marginTop: "8px",
            borderRadius: "6px",
            fontFamily: "Montserrat",
            fontWeight: "bold",
            backgroundColor: "#336B87",
            color: "#FFF",
          }}
        >
          <Box
            sx={{
              width: "40px",
              display: "flex",
              justifyContent: "center",
              mr: "8px",
            }}
          >
            <Checkbox
              checked={
                toAddUsers.length === missingUsers.length &&
                missingUsers.length > 0
              }
              indeterminate={
                toAddUsers.length > 0 && toAddUsers.length < missingUsers.length
              }
              onChange={toggleSelectAll}
              disabled={isAdding}
              icon={<CheckBoxOutlineBlankIcon sx={{ color: "#FFF" }} />}
              checkedIcon={<CheckBoxIcon sx={{ color: "#FFF" }} />}
              indeterminateIcon={
                <IndeterminateCheckBoxIcon sx={{ color: "#FFF" }} />
              }
              sx={{
                padding: 0,
              }}
            />
          </Box>
          <Typography sx={{ flex: 1 }}>Nombre</Typography>
          <Typography sx={{ flex: 1 }}>Email</Typography>
        </Box>
      )}

      {/* Contenedor con scroll */}
      <Box
        sx={{
          marginTop: "8px",
          paddingTop: "8px",
          borderTop: "1px solid rgba(51, 107, 135, 0.5)",
          maxHeight: "350px",
          overflowY: "auto",
        }}
      >
        {/* Lista de usuarios */}
        {filteredUsers.length > 0 ? (
          filteredUsers.map((usuario) => (
            <Box
              key={usuario.id_usuario}
              sx={{ display: "flex", alignItems: "center", padding: "4px 8px" }}
            >
              <Checkbox
                checked={toAddUsers.includes(usuario.id_usuario)}
                disabled={isAdding}
                onChange={() => handleCheckboxChange(usuario.id_usuario)}
                sx={{
                  color: "#336B87",
                  "&.Mui-checked": { color: "#336B87" },
                  marginRight: "8px",
                }}
              />
              <Typography sx={{ flex: 1, color: "#000" }}>
                {usuario.nombres} {usuario.apellidos}
              </Typography>
              <Typography sx={{ flex: 1, color: "#73767E" }}>
                {usuario.email}
              </Typography>
            </Box>
          ))
        ) : (
          <Typography
            color="#73767E"
            fontStyle="italic"
            textAlign="center"
            mt={2}
          >
            No hay usuarios disponibles
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default OtherUsersMenu;